import Layout from "@/layout";
import { useAppSelector } from "@/store";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setupAxiosInterceptors } from "@/facilities/http";

function App() {
  const navigate = useNavigate();
  const darkMode = useAppSelector((state) => state.app.theme);
  useEffect(() => {
    setupAxiosInterceptors(navigate);
  }, [navigate]);
  return (
    <div className={darkMode}>
      <Layout />
    </div>
  );
}

export default App;
